import React from "react";
import Select from "react-select";
import InputText from "../../../common/Input/InputText";
import styles from "../editLabReport.module.scss";

const sectionConfig = {
  "COMPLETE BLOOD COUNT (CBC)": [
    "White Blood Cell(WBC)",
    "Red Blood Cell(RBC)",
    "Haemoglobin",
    "Hematocrit",
    "Mean Corpuscular Volume(MCV)",
    "Mean Corpuscular Haemoglobin(MCH)",
    "Mean Corpuscular Haemoglobin Concentration(MCHC)",
    "RDW-CV",
    "RDW-SD",
    "Platelet Count",
    "MPV",
    "PDW",
    "PCT",
    "P-LCC",
    "P-LCR",
  ],

  "Differential Leucocytes Count(DLC)": [
    "Neutrophils",
    "Lymphocytes",
    "Eosinophils",
    "Monocytes",
    "Basophils",
  ],

  "Absolute Leucocyte Count (ALC)": [
    "Absolute Neutrophils",
    "Absolute Lymphocytes",
    "Absolute Eosinophils",
    "Absolute Monocytes",
    "Absolute Basophils",
  ],
};

const CBCProfile = ({
  profile,
  testMap,
  handleTestProfileChange,
  getProfileMethods,
}) => {
  const renderField = (item, index) => {
    const testData = testMap.get(item._id) || {};

    let highRange;
    let lowRange;

    if (item?.patientId?.userId?.age?.year < 10) {
      highRange = item?.ihigh_range;
      lowRange = item?.ilow_range;
    } else {
      if (item?.patientId?.userId?.gender === "Male") {
        highRange = item?.mhigh_range;
        lowRange = item?.mlow_range;
      } else if (item?.patientId?.userId?.gender === "Female") {
        highRange = item?.fhigh_range;
        lowRange = item?.flow_range;
      } else {
        highRange = item?.high_range;
        lowRange = item?.low_range;
      }
    }

    return (
      <div className={styles.testAndProfileWrapper} key={item._id}>
        {/* Test Name */}
        <div className={styles.inputWrapper}>
          <InputText value={item?.testName} label="Test Name" readOnly />
        </div>

        {/* Category */}
        {/* <div className={styles.inputWrapper}>
          <InputText
            value={item?.category?.categoryName}
            label="Category"
            readOnly
          />
        </div> */}

        {/* Method */}
        <div className={styles["inputWrapper"]}>
                                      <div className="form-group">
                                        <InputText
                                          value={item?.testMethod?.name}
                                          readOnly={true}
                                          label="Method"
                                        />
                                      </div>
                                    </div>

        {/* Value */}
        <div className={styles.inputWrapper}>
          <InputText
            label="Value"
            value={testData?.value || ""}
            className="lab-value"
            onChange={(e) =>
              handleTestProfileChange(e, "value", profile._id, item._id)
            }
          />
        </div>
        {/* Is NABL Approved */}
<div className={styles.inputWrapper}>
  <label className="col-form-label">Is NABL Approved</label>

  <Select
    placeholder="Select"
    value={
      testData?.isNABL
        ? {
            value: testData.isNABL,
            label: testData.isNABL,
          }
        : null
    }
    onChange={(e) =>
      handleTestProfileChange(e, "isNABL", profile._id, item._id)
    }
    options={[
      { value: "Yes", label: "Yes" },
      { value: "No", label: "No" },
    ]}
  />
</div>

        {/* Low Value */}
        <div className={styles.inputWrapper}>
          <InputText label="Low Value" value={lowRange} readOnly />
        </div>

        {/* High Value */}
        <div className={styles.inputWrapper}>
          <InputText label="High Value" value={highRange} readOnly />
        </div>

        {/* Reference Range */}
        <div className={styles.inputWrapper}>
          <InputText
            label="Reference Range"
            value={item?.reference_range_details}
            readOnly
          />
        </div>

        {/* Units */}
        <div className={styles.inputWrapper}>
          <InputText label="Units" value={item?.units} readOnly />
        </div>
      </div>
    );
  };

  return (
    <>
      {Object.entries(sectionConfig).map(([section, tests]) => {
        const sectionTests = profile?.tests?.filter((test) =>
          tests.includes(test.testName),
        );

        if (!sectionTests?.length) return null;

        return (
          <div key={section}>
            <h4
              style={{
                marginTop: 20,
                marginBottom: 15,
                fontWeight: 600,
              }}
            >
              {section}
            </h4>

            {sectionTests.map(renderField)}
          </div>
        );
      })}
    </>
  );
};

export default CBCProfile;
